import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { GridLegacy, IconButton, List, ListItem, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../components/CustomButtons/Button";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import { ProductAttributes } from "../../../../../Domains/Products/api/productJsonApi.js";
import { GET_PRODUCTS } from "../../../../../Domains/Products/api/productGraphQLApi.js";
import { RenderOption } from "../../OptionGroups/Tabs/AutocompleteProductRenderOption.js";
import { AutocompleteCategory, AutocompleteProduct } from "@jamezz/react-components";
import { GET_PRODUCT_GROUPS } from "../../../../../Domains/ProductGroups/productGraphQLApi.ts";
import _ from "lodash";

export default function ChildProducts() {
  return (
    <>
      <Products />
      <Categories />
    </>
  );
}
function Products() {
  const { control, menukaartVestigingId } = useFormContext();
  const { fields, append, replace, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "products",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <List>
              <ListItem>
                <GridLegacy container>
                  <GridLegacy item xs={4}>
                    <TranslationWrapper tKey={"Product name"} />
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <TranslationWrapper tKey={"Product default sort key"} />
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <TranslationWrapper tKey={"Sort key"} />
                  </GridLegacy>
                  <GridLegacy item xs={4} />
                </GridLegacy>
              </ListItem>

              {fields.map((field, index) => {
                return (
                  <ListItem>
                    <GridLegacy container>
                      <GridLegacy item xs={4}>
                        <Typography style={{ margin: "0 16px" }}>{field.naam}</Typography>
                      </GridLegacy>

                      <GridLegacy item xs={4}>
                        <IconButton
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <Delete />
                        </IconButton>

                        <Link to={`/manager/producten/${field.id}/edit`}>
                          <Tooltip
                            classes={{}}
                            placement={"bottom"}
                            title={
                              <TranslationWrapper tDefault={"View Product"} tKey={"global.jamezzTable.viewProduct"} />
                            }
                          >
                            <Button color={"success"} simple>
                              <Edit />
                            </Button>
                          </Tooltip>
                        </Link>
                      </GridLegacy>
                    </GridLegacy>
                  </ListItem>
                );
              })}
            </List>
          </GridLegacy>
        </GridLegacy>

        <AutocompleteProduct<true, ProductAttributes, true>
          multiple
          value={fields.map((field) => Number(field.id))}
          fetchQuery={GET_PRODUCTS}
          defaultFilters={{ vestiging_id: { field: "vestiging_id", operator: "=", value: menukaartVestigingId } }}
          menuSalesareaId={menukaartVestigingId}
          inputFieldProps={{ sx: { minWidth: 300 } }}
          onChange={(product) => {
            replace(product);
          }}
          renderOption={(props, option) => <RenderOption option={option} />}
        />
      </CardBody>
    </Card>
  );
}
function Categories() {
  const { control, menukaartVestigingId } = useFormContext();
  const { fields, append, replace, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "product_groups",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <List>
              <ListItem>
                <GridLegacy container>
                  <GridLegacy item xs={4}>
                    <TranslationWrapper tKey={"Category name"} />
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <TranslationWrapper tKey={"Category default sort key"} />
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <TranslationWrapper tKey={"Sort key"} />
                  </GridLegacy>
                  <GridLegacy item xs={4} />
                </GridLegacy>
              </ListItem>

              {fields.map((field, index) => {
                return (
                  <ListItem>
                    <GridLegacy container>
                      <GridLegacy item xs={4}>
                        <Typography style={{ margin: "0 16px" }}>{field.naam}</Typography>
                      </GridLegacy>

                      <GridLegacy item xs={4}>
                        <IconButton
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <Delete />
                        </IconButton>

                        <Link to={`/manager/kaarten/${field.id}/edit`}>
                          <Tooltip
                            classes={{}}
                            placement={"bottom"}
                            title={
                              <TranslationWrapper tDefault={"View Category"} tKey={"global.jamezzTable.viewCategory"} />
                            }
                          >
                            <Button color={"success"} simple>
                              <Edit />
                            </Button>
                          </Tooltip>
                        </Link>
                      </GridLegacy>
                    </GridLegacy>
                  </ListItem>
                );
              })}
            </List>
          </GridLegacy>
        </GridLegacy>

        <AutocompleteCategory<true, { id: number; naam: string }, true>
          multiple
          value={fields.map((field) => Number(field.id))}
          fetchQuery={GET_PRODUCT_GROUPS}
          defaultFilters={{ vestiging_id: { field: "vestiging_id", operator: "=", value: menukaartVestigingId } }}
          menuSalesareaId={menukaartVestigingId}
          inputFieldProps={{ sx: { minWidth: 300 } }}
          onChange={(categories) => {
            replace(
              categories.map((category) => {
                const c = _.cloneDeep(category);
                delete c["__typename"];
                return c;
              })
            );
          }}
        />
      </CardBody>
    </Card>
  );
}
